import { useQuery } from 'data-fetching-client';
import * as React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UISection from 'UIComponents/section/UISection';
import EnrollmentDiagnosisFailureMessage from 'flow-doctor-lib/components/diagnosis/EnrollmentDiagnosisFailureMessage';
import EnrollmentDiagnosisPanelBodyHeader from 'flow-doctor-lib/components/diagnosis/EnrollmentDiagnosisPanelBodyHeader';
import EnrollmentDiagnosisPanelTabs from 'flow-doctor-lib/components/diagnosis/tabs/EnrollmentDiagnosisPanelTabs';
import FlowDoctorHandlerContext, { FlowDoctorHandlerContextProvider } from 'flow-doctor-lib/context/FlowDoctorHandlerContext';
import { GET_FLOW_DOCTOR_ENROLLMENT_DIAGNOSIS } from 'flow-doctor-lib/queries/FlowDoctorQueries';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LONG_LOADING_TIMEOUT_MS = 7000;
const EnrollmentDiagnosisPanelBody = ({
  enrollmentEvent,
  failureMarker,
  successMarker
}) => {
  const [hasLongLoadingState, setHasLongLoadingState] = React.useState(false);
  const {
    onViewRevision
  } = React.useContext(FlowDoctorHandlerContext);
  const {
    data: diagnosisData,
    loading: loadingDiagnosis,
    error: diagnosisError
  } = useQuery(GET_FLOW_DOCTOR_ENROLLMENT_DIAGNOSIS, {
    variables: {
      portalId: enrollmentEvent.portalId,
      enrollmentId: enrollmentEvent.enrollmentId
    }
  });
  React.useEffect(() => {
    const timeoutId = setTimeout(() => setHasLongLoadingState(true), LONG_LOADING_TIMEOUT_MS);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);
  const {
    failureReason,
    diagnosisResult
  } = diagnosisData ? diagnosisData.flowDoctorEnrollmentDiagnosis : {
    failureReason: undefined,
    diagnosisResult: undefined
  };
  if (diagnosisError) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [failureMarker, /*#__PURE__*/_jsx(UIErrorMessage, {
        type: "badRequest",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.errorState.title"
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.errorState.descriptionDiagnosis"
        })
      })]
    });
  }
  if (loadingDiagnosis) {
    return /*#__PURE__*/_jsxs(UISection, {
      className: "m-top-10",
      children: [/*#__PURE__*/_jsx(UILoadingSpinner, {
        layout: "centered"
      }), hasLongLoadingState && /*#__PURE__*/_jsx("div", {
        style: {
          textAlign: 'center'
        },
        children: /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.stillLoading"
          })
        })
      })]
    });
  }
  if (failureReason) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [successMarker, /*#__PURE__*/_jsx(EnrollmentDiagnosisFailureMessage, {
        failureReason: failureReason
      })]
    });
  }
  return /*#__PURE__*/_jsxs(FlowDoctorHandlerContextProvider, {
    value: {
      onViewRevision
    },
    children: [successMarker, /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(View, {
        paddingInline: "1000",
        marginBlockEnd: "500",
        as: "div",
        children: /*#__PURE__*/_jsx(EnrollmentDiagnosisPanelBodyHeader, {
          diagnosisResult: diagnosisResult,
          enrollmentEvent: enrollmentEvent
        })
      }), /*#__PURE__*/_jsx(EnrollmentDiagnosisPanelTabs, {
        diagnosisResult: diagnosisResult,
        selectedEnrollment: enrollmentEvent
      })]
    })]
  });
};
export default EnrollmentDiagnosisPanelBody;